import template from "./entity-business.html";
import "./entity-business.less";
import veslLogo from "../../../../../../images/vesl_logo.svg";

import { FORM_ENTITY_BUSINESSES } from "routes";

import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../../../services/i18nService";
import { globs } from "../../../../../../services/globs";
import {
	All, 
	Pattern 
} from "../../../../../../services/security/actionScopes";
import { runEntityBusinessModal } from "./entity-business-modal/run-entity-business-modal";

export function controller($logger, api, appState, loadingService, $uibModal, securityService, entityBusinessService) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;
	ctrl.business = null;
	ctrl.businesses = [];
	ctrl.selectedBusinessId = undefined;
	ctrl.veslLogo = veslLogo;

	ctrl.$onInit = () => {
		loadBusinesses();

		setupSecurity();
	};

	ctrl.editBusiness = async() => {
		try {
			if(ctrl.business === undefined) {
				ctrl.business = {
					Name: ctrl.entity.Name
				};
			}

			ctrl.business = await runEntityBusinessModal($uibModal, ctrl.business, saveBusiness);

			// When editing/creating from empty state, ensure lists reflect selection
			if(ctrl.business && ctrl.business.Id !== undefined) {
				ctrl.selectedBusinessId = ctrl.business.Id;
				// If this was the first creation, add to list
				const exists = ctrl.businesses.some(b => b.Id === ctrl.business.Id);
				if(!exists) {
					ctrl.businesses.push(ctrl.business);
				}
			}
		}
		catch(err) {
			ctrl.business = undefined;
		}
	};

	ctrl.addBusiness = async() => {
		try {
			const newBusiness = { Name: ctrl.entity.Name };

			const created = await runEntityBusinessModal($uibModal, newBusiness, saveBusiness);

			if(created) {
				// Refresh list to ensure server state
				await loadBusinesses(true);

				ctrl.business = created;
				ctrl.selectedBusinessId = created.Id;
			}
		}
		catch(err) {
			// No change on cancel
		}
	};

	ctrl.onSelectedBusinessChange = () => {
		const found = ctrl.businesses.find(b => b.Id === ctrl.selectedBusinessId);
		if(found) {
			ctrl.business = found;
		}
	};

	function setupSecurity() {
		ctrl.canCreateBusinessGlob = globs.business.byType("*").create;
		ctrl.canCreateEntityBusinessGlob = globs.entityTypes.byType(ctrl.typeConfig.Code).business.byType("*").create;
		ctrl.canCreateActionScope = new All([
			new Pattern(ctrl.canCreateBusinessGlob),
			new Pattern(ctrl.canCreateEntityBusinessGlob)
		]);
	}

	async function loadBusinesses(forceReload = false) {
		const canReadBuiness = securityService.isPatternAllowed(globs.business.byType("*").read);
		if(!canReadBuiness) {
			ctrl.business = undefined;
			return;
		}

		const getBusinesses = entityBusinessService.getBusinessesForEntity(appState.forms.selected.Id, ctrl.entity.Id, { forceReload });
		// returns { IsActive: boolean, Business: Profile }[]

		const businesses = await loadingService.watch(getBusinesses);

		//businesses = businesses.filter(b => b.IsActive);

		ctrl.businesses = businesses.map(b => b.Business);

		if(ctrl.businesses.length > 0) {
			if(ctrl.selectedBusinessId === undefined || forceReload) {
				ctrl.business = ctrl.businesses[0];
				ctrl.selectedBusinessId = ctrl.business.Id;
			}
		}
		else {
			ctrl.business = undefined;
			ctrl.selectedBusinessId = undefined;
		}
	}

	async function saveBusiness(business) {
		const saveBusiness = ctrl.post(FORM_ENTITY_BUSINESSES(appState.forms.selected.Id, ctrl.entity.Id), business);
		const resp = await loadingService.watch(saveBusiness);
		entityBusinessService.invalidateBusinessesForEntity(appState.forms.selected.Id, ctrl.entity.Id);

		return resp;
	}
}

export default angular.module("vesl.components.entity-business", [])
	.component("entityBusiness", {
		controller,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
